import Vue from 'vue'

import throttle from 'lodash.throttle'
const scrollSpyContext = '@@scrollSpyContext'

function createSpyElement(parent) {
    const el = document.createElement('div')
    el.style.visibility = 'hidden'
    parent.appendChild(el)
    return el
}

Vue.directive('scroll-spy', {
    bind(el, binding) {
        function onScroll() {
            const { spyEl, pageYOffsetBefore } = el[scrollSpyContext]
            if (!spyEl) return
            let e = spyEl
            let top = spyEl.offsetTop
            let height = spyEl.offsetHeight
            while (e.offsetParent) {
                e = e.offsetParent
                top += e.offsetTop
            }
            el[scrollSpyContext].pageYOffsetBefore = window.pageYOffset
            if (
                top < window.pageYOffset + window.innerHeight &&
                top + height > window.pageYOffset &&
                typeof binding?.value === 'function' &&
                pageYOffsetBefore !== window.pageYOffset
            )
                binding.value()
        }
        const throttleScroll = throttle(async () => {
            onScroll()
        }, 500)

        el[scrollSpyContext] = {
            onScroll,
            throttleScroll,
            pageYOffsetBefore: 0,
            spyEl: createSpyElement(el),
        }
    },

    inserted(el) {
        const { onScroll, throttleScroll } = el[scrollSpyContext]
        window.addEventListener('scroll', throttleScroll)
        onScroll()
    },

    componentUpdated(el) {
        const { spyEl } = el[scrollSpyContext]
        if (spyEl) el.removeChild(spyEl)
        el[scrollSpyContext].spyEl = createSpyElement(el)
    },

    unbind(el) {
        const { throttleScroll } = el[scrollSpyContext]
        window.removeEventListener('scroll', throttleScroll)
    },
})
